<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-command`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M44 12a8 8 0 10-16 0v4h-8v-4a8 8 0 10-8 8h4v8h-4l-.25.004A8 8 0 1020 36v-4h8v4a8 8 0 108-8h-4v-8h4l.25-.004A8 8 0 0044 12zM12 32h4v4l-.005.2A4 4 0 1112 32zm24 0h-4v4a4 4 0 104-4zM20 20h8v8h-8v-8zM12 8a4 4 0 100 8h4v-4a4 4 0 00-4-4zm20.005 3.8A4 4 0 1136 16h-4v-4l.005-.2z"/></svg>
</template>
<script>

export default {
  name: 'IconCommand',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
